import load from '#core/load';


const module = {
	init() {
		load.content(() => {
			document.querySelectorAll('.quiz-step__form').forEach(form => {
				module.setup(form);
			});
		});
	},

	setup(form) {
		const steps = [...form.querySelectorAll('.quiz-step__step')];
		let current = 0;

		const show = (index) => {
			steps.forEach((step, i) => {
				step.hidden = i !== index;
			});
			current = index;
			form.closest('.quiz-step').scrollIntoView({ behavior: 'smooth', block: 'start' });
		};

		// Radio inputs with data-quiz-next auto-advance
		form.querySelectorAll('input[data-quiz-next]').forEach(input => {
			input.addEventListener('change', () => {
				if (current < steps.length - 1) show(current + 1);
			});
		});

		/*
		 * Sync the hidden promoted_action input with the checked answer.
		 * Answers can carry a promoted action (data-promoted-action) that
		 * the results page shows as the first result. The input stays
		 * disabled when no promoted answer is selected so the param is
		 * omitted from the submission.
		 */
		const promoted_input = form.querySelector('input[name="promoted_action"]');
		if (promoted_input) {
			form.querySelectorAll('input[type="radio"]').forEach(radio => {
				radio.addEventListener('change', () => {
					const checked = form.querySelector('input[type="radio"][data-promoted-action]:checked');
					const promoted = checked ? checked.getAttribute('data-promoted-action') : '';
					promoted_input.value = promoted;
					promoted_input.disabled = !promoted;
				});
			});
		}

		// Continue / next buttons
		form.querySelectorAll('button[data-quiz-next]').forEach(btn => {
			btn.addEventListener('click', () => {
				if (current < steps.length - 1) show(current + 1);
			});
		});

		// Back buttons
		form.querySelectorAll('.quiz-step__back-btn[data-quiz-back]').forEach(btn => {
			btn.addEventListener('click', () => {
				if (current > 0) show(current - 1);
			});
		});

		// Tag checkbox visual toggle
		form.querySelectorAll('.quiz-step__tag input[type="checkbox"]').forEach(checkbox => {
			checkbox.addEventListener('change', () => {
				checkbox.closest('.quiz-step__tag').classList.toggle('is-selected', checkbox.checked);
			});
		});

		/*
		 * Email signup on the last step. The subscribe endpoint (e.g. the
		 * VoterVoice listener) is posted to via sendBeacon so the request
		 * survives the navigation to the results page. The email input is
		 * then disabled so the address is not carried into the results
		 * page query string.
		 */
		form.addEventListener('submit', () => {
			const subscribe_url = form.getAttribute('data-subscribe-url');
			const email_input = form.querySelector('input[name="email"]');
			if (!subscribe_url || !email_input || !email_input.value) return;

			const data = new FormData();
			data.append('email', email_input.value);
			navigator.sendBeacon(subscribe_url, data);

			email_input.disabled = true;
		});
	},
};

export default module;
module.init();
